import moment from "moment";
import React, { useState, useEffect } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { allFieldsFilled } from "../../helpers/form";
import {
  formCreatorConvertToValues,
  useForm,
  getField,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import { postABMForms } from "../../redux/actions/abmActions";

const PersonalInformationForm = ({ appData, postABMFormFunc }) => {
  const {
    firstName = "",
    lastName = "",
    homeTelephone = "",
    mobileTelephone = "",
    emailAddress,
    nationalInsuranceNo,
    title,
    gender = "",
    address,
  } = appData;

  let initialData = {
    PersonalInformation1: title,
    PersonalInformation2: lastName,
    PersonalInformation4: firstName,
    PersonalInformation8: gender,
    PersonalInformation9: appData.dateOfBirth
      ? moment(appData.dateOfBirth).format("DD/MM/YYYY")
      : "",
    PersonalInformation10: homeTelephone || mobileTelephone,
    PersonalInformation11: emailAddress,
    PersonalInformation17:
      address &&
      address.addressLine1 +
        (address.addressLine2 ? `, ${address.addressLine2}` : "") +
        (address.addressLine3 ? `, ${address.addressLine3}` : "") +
        (address.town ? `, ${address.town}` : "") +
        (address.county ? `, ${address.county}` : "") +
        (address.postcode ? `, ${address.postcode}` : ""),
    SecurityInterview1: nationalInsuranceNo, // ninF
  };

  if (appData.abmOnboarding && appData.abmOnboarding.personalInfo) {
    initialData = {
      ...initialData,
      ...appData.abmOnboarding.personalInfo,
    };
  }

  let initialAddressHistory = [
    {
      "Country of Residence": "",
      From: "",
      To: "",
      "Revisited since your residence ended?": false,
    },
  ];

  const isHistoryFilled = !!(
    appData.abmOnboarding &&
    appData.abmOnboarding.personalInfo &&
    appData.abmOnboarding.personalInfo.addressHistoryData
  );

  if (isHistoryFilled) {
    initialAddressHistory = Object.keys(
      appData.abmOnboarding.personalInfo.addressHistoryData
    ).map((key) => appData.abmOnboarding.personalInfo.addressHistoryData[key]);
  }

  const [showAddress, setShowAddress] = useState(isHistoryFilled);

  const getVal = getField(initialData);

  const initialErrorMessagesAddress = [
    {
      toAfterFromDate: "",
      tooBigGap: "",
      toExceedsFrom: "",
    },
  ];

  const [shouldDisableAddress, setshouldDisableAddress] = useState(false);

  const [addressHistoryData, setAddressHistoryData] = useState(
    initialAddressHistory
  );

  const [validationErrorMessageAddress, setValidationErrorMessageAddress] =
    useState(initialErrorMessagesAddress);

  const xYearsAddressErrorMessage = "";

  const setValueAddress = (value, key, i) => {
    const mappedHistoryData = addressHistoryData.map((el, index) => {
      if (i === index) {
        return { ...el, [key]: value };
      }
      return el;
    });

    setAddressHistoryData(mappedHistoryData);
  };

  const removeLastAddress = () => {
    const newArr = [...addressHistoryData];
    newArr.splice(newArr.length - 1);
    setAddressHistoryData(newArr);
  };

  const checkErrorMessagesEmpty = (validationMessages) => {
    let areErrorMessagesEmpty = true;
    validationMessages.forEach((el) => {
      Object.keys(el).forEach((key) => {
        if (el[key]) areErrorMessagesEmpty = false;
      });
    });
    return areErrorMessagesEmpty;
  };

  const addressHandle = (_, value) => {
    setShowAddress(value);
  };
  const initialState = {
    PersonalInformation31: {
      title: "Important Information",
      type: "heading",
      textDescription: [
        "You are respectfully advised that it is an offence, under the Aviation Security Act 1982, as amended by the Aviation and Maritime Security Act 1990, to knowingly give false information, either for the purpose of, or in connection with, an application for an airport security ID pass.",
      ],
    },
    PersonalInformation25: {
      title: "Have you previously held an airside pass at a UK airport before",
      value: getVal("PersonalInformation25"),
      type: "checkbox",
      mandatory: true,
    },
    PersonalInformation26: {
      title: "If Yes which Airport?",
      value: getVal("PersonalInformation26"),
      type: "text",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "PersonalInformation25",
        },
      ],
    },
    PersonalInformation27: {
      title: "Company Name which pass was held with (if applicable)",
      value: getVal("PersonalInformation27"),
      type: "text",
      mandatory: false,
      dependOn: [
        {
          fieldKey: "PersonalInformation25",
        },
      ],
    },
    PersonalInformation28: {
      title: "Prefix & ID Number e.g. HAL 119281 (if applicable)",
      value: getVal("PersonalInformation28"),
      type: "text",
      mandatory: false,
      dependOn: [
        {
          fieldKey: "PersonalInformation25",
        },
      ],
    },
    PersonalInformation29: {
      title: "Have you previously completed a GSAT test?",
      value: getVal("PersonalInformation29"),
      type: "checkbox",
      mandatory: true,
    },
    PersonalInformation30: {
      title: "Date of GSAT",
      value: getVal("PersonalInformation30"),
      type: "text",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "PersonalInformation29",
        },
      ],
    },
    PersonalInformation1: {
      title: "Title",
      value: getVal("PersonalInformation1"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation2: {
      title: "Surname (as on proof of ID being used)",
      value: getVal("PersonalInformation2"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation3: {
      title: "Your Maiden Name (if applicable)",
      value: getVal("PersonalInformation3"),
      type: "text",
      mandatory: false,
    },
    SecurityInterview8: {
      title: "Do you have any Middle Names?",
      value: getVal("SecurityInterview8"),
      type: "checkbox",
      mandatory: true,
    },
    SecurityInterview9: {
      title: "Middle Names",
      value: getVal("SecurityInterview9"),
      type: "text",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "SecurityInterview8",
        },
      ],
    },
    PersonalInformation4: {
      title: "First and Middle names (as on proof of ID being used)",
      value: getVal("PersonalInformation4"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation5: {
      title: "Mother’s Maiden Name (surname she was born with/before marriage)",
      value: getVal("PersonalInformation5"),
      type: "text",
      mandatory: true,
    },
    SecurityInterview2: {
      title:
        "Have you officially been known by a different name to that stated above?",
      value: getVal("SecurityInterview2"),
      type: "checkbox",
      mandatory: true,
    },
    // SecurityInterview3: {
    //   title:
    //     "Please provide details of all previous names and the specific dates that they relate to.",
    //   value: getVal("SecurityInterview3"),
    //   type: "textarea",
    //   mandatory: true,
    //   dependOn: [
    //     {
    //       fieldKey: "SecurityInterview2",
    //     },
    //   ],
    // },
    // PersonalInformation6: {
    //   title: "Any other names that you have been known by",
    //   value: getVal("PersonalInformation6"),
    //   type: "text",
    //   mandatory: false,
    // },
    PrevName1: {
      title: "Previous name",
      value: getVal("PrevName1"),
      type: "text",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "SecurityInterview2",
        },
      ],
    },
    PrevDate1: {
      title: "Date of name change",
      value: getVal("PrevDate1"),
      type: "text",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "SecurityInterview2",
        },
      ],
    },
    PrevName2: {
      title: "Previous name",
      value: getVal("PrevName2"),
      type: "text",
      mandatory: false,
      dependOn: [
        {
          fieldKey: "SecurityInterview2",
        },
      ],
    },
    PrevDate2: {
      title: "Date of name change",
      value: getVal("PrevDate2"),
      type: "text",
      mandatory: false,
      dependOn: [
        {
          fieldKey: "SecurityInterview2",
        },
      ],
    },
    PrevName3: {
      title: "Previous name",
      value: getVal("PrevName3"),
      type: "text",
      mandatory: false,
      dependOn: [
        {
          fieldKey: "SecurityInterview2",
        },
      ],
    },
    PrevDate3: {
      title: "Date of name change",
      value: getVal("PrevDate3"),
      type: "text",
      mandatory: false,
      dependOn: [
        {
          fieldKey: "SecurityInterview2",
        },
      ],
    },
    PersonalInformation8: {
      title: "Gender",
      value: getVal("PersonalInformation8"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation9: {
      title: "Date of Birth",
      value: getVal("PersonalInformation9"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation10: {
      title: "Contact Number",
      value: getVal("PersonalInformation10"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation11: {
      title: "Email Address",
      value: getVal("PersonalInformation11"),
      type: "text",
      mandatory: true,
    },
    SecurityInterview1: {
      title: "National Insurance Number (or equivalent)",
      value: getVal("SecurityInterview1"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation12: {
      title: "Town of Birth",
      value: getVal("PersonalInformation12"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation13: {
      title: "Country of Birth",
      value: getVal("PersonalInformation13"),
      type: "text",
      mandatory: true,
    },
    SecurityInterview4: {
      title:
        "If your Place of Birth is outside of the UK, please enter date first entered UK.",
      value: getVal("SecurityInterview4"),
      type: "text",
      mandatory: false,
    },
    PersonalInformation14: {
      title: "Type of ID: Passport, Driving Licence (if born in the UK)",
      value: getVal("PersonalInformation14"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation15: {
      title: "Nationality of Proof of ID",
      value: getVal("PersonalInformation15"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation16: {
      title: "ID Number of Proof of ID",
      value: getVal("PersonalInformation16"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation17: {
      title: "Current Full Residential Address including postcode",
      value: getVal("PersonalInformation17"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation18: {
      title: "Date moved into current address (month and year)",
      value: getVal("PersonalInformation18"),
      type: "text",
      mandatory: true,
    },
    PersonalInformation19: {
      title:
        "Previous Full Residential Address including Postcode (if less than 5 years at current address)",
      value: getVal("PersonalInformation19"),
      type: "text",
      mandatory: false,
    },
    PersonalInformation20: {
      title: "Date moved into this address (month and year)",
      value: getVal("PersonalInformation20"),
      type: "text",
      mandatory: false,
    },
    PersonalInformation21: {
      title:
        "Previous Full Residential Address including Postcode (if applicable)",
      value: getVal("PersonalInformation21"),
      type: "text",
      mandatory: false,
    },
    PersonalInformation22: {
      title: "Date moved into this address (month and year)",
      value: getVal("PersonalInformation22"),
      type: "text",
      mandatory: false,
    },
    PersonalInformation23: {
      title:
        "Previous Full Residential Address including Postcode (if applicable)",
      value: getVal("PersonalInformation23"),
      type: "text",
      mandatory: false,
    },
    PersonalInformation24: {
      title: "Date moved into this address (month and year)",
      value: getVal("PersonalInformation24"),
      type: "text",
      mandatory: false,
    },
    SecurityInterview24: {
      title:
        "Have you resided outside of the UK in the last 5 years? (Holidays and trips of less than 28 days need not be included)",
      value: getVal("SecurityInterview24"),
      type: "checkbox",
      mandatory: true,
      customFunc: addressHandle,
    },
    SecurityInterview25: {
      title: "Residence outside of the UK",
      type: "heading",
      textDescription: [
        "If you have answered yes, you are required to state all the locations you have resided. All locations need to be included, even if they overlap.",
      ],
      dependOn: [
        {
          fieldKey: "SecurityInterview24",
        },
      ],
    },
    SecurityInterview26: {
      type: "addressHistoryV2",
      addressHistoryColumns: [
        {
          title: "Country of Residence",
          type: "text",
          mandatory: "true",
          format: "",
        },
        { title: "From", type: "date", mandatory: "true", format: "date" },
        { title: "To", type: "date", mandatory: "true", format: "date" },
        {
          title: "Revisited since your residence ended?",
          type: "checkbox",
          format: "",
        },
      ],
      addressHistoryYrs: "0",
      onlyPrevious: true,
      initialAddressHistory: {
        "Country of Residence": "",
        From: "",
        To: "",
        "Revisited since your residence ended?": "",
      },
      dependOn: [
        {
          fieldKey: "SecurityInterview24",
        },
      ],
    },
  };

  const [fields, setField] = useForm(initialState);

  useEffect(() => {
    let areAllFieldsFilled = true;
    let areErrorMessagesEmpty = true;

    const validationMessages = addressHistoryData.map(() => ({}));

    // check if there are no empty values

    areAllFieldsFilled = allFieldsFilled(addressHistoryData, [
      "Revisited since your residence ended?",
    ]);
    // : true; // check if there are no empty values

    areErrorMessagesEmpty = checkErrorMessagesEmpty(validationMessages); // check no error messages

    if (addressHistoryData[0].To && addressHistoryData[0].From) {
      let oldestDate = moment(addressHistoryData[0].To).format("YYYY-MM-DD");
      let earliestDate = moment(addressHistoryData[0].From).format(
        "YYYY-MM-DD"
      );

      addressHistoryData.forEach((el, i) => {
        const from = el.From ? moment(el.From).format("YYYY-MM-DD") : null;
        const to = el.To ? moment(el.To).format("YYYY-MM-DD") : null;

        // Validation if 'from' date is before 'to' date validation
        if (from && to && moment(to).isBefore(from)) {
          const prev = validationMessages[i] ? validationMessages[i] : {};
          validationMessages[i] = {
            ...prev,
            toAfterFromDate: "From date can not be after to date",
          };
        }

        // find the oldest from date
        if (from && moment(from).isBefore(oldestDate)) {
          oldestDate = from;
        }

        if (to && moment(to).isAfter(earliestDate)) {
          earliestDate = to;
        }
      });

      // Validation so that the previous end date must be -1 day e.g row 1 from date 01/01/2020 the previous to date will be 31/12/2019
      for (let i = 0; addressHistoryData.length - 1; i += 1) {
        if (i === addressHistoryData.length - 1) {
          break;
        }
        if (
          addressHistoryData[i + 1].From &&
          addressHistoryData[i + 1].To &&
          addressHistoryData[i].From &&
          addressHistoryData[i].To
        ) {
          const end = moment(addressHistoryData[i + 1].To, "YYYY/MM/DD"); // end date (to field) of next address row
          const start = moment(addressHistoryData[i].From, "YYYY/MM/DD"); // start date (from field) of current address row
          const r = moment(start).diff(moment(end), "days", false);
          if (r > 1) {
            const prev = validationMessages[i + 1]
              ? validationMessages[i + 1]
              : {};
            validationMessages[i + 1] = {
              ...prev,
              tooBigGap: `The "From" date entered for Address ${
                i + 1
              } has a difference of more than 1 day from the "To" date entered for Address ${
                i + 2
              }.
                                        Please ensure the dates are at most 1 day apart.`,
            };
          }

          // deal with the To date of next row exceeding the from date of the current row (the end of the previous address cannot be more than when they moved into the next address)
          if (end > start) {
            const prev = validationMessages[i + 1]
              ? validationMessages[i + 1]
              : {};
            validationMessages[i + 1] = {
              ...prev,
              toExceedsFrom: `The "To" date entered for Address ${
                i + 2
              } cannot be after the "From" date entered for Address ${i + 1}.
                                        Please ensure the "To" date is before the "From" date for the above address rows.`,
            };
          }
        }
      }
    }
    setValidationErrorMessageAddress(validationMessages);

    if (showAddress) {
      if (
        areAllFieldsFilled &&
        areErrorMessagesEmpty &&
        xYearsAddressErrorMessage === ""
      ) {
        setshouldDisableAddress(false);
      } else {
        setshouldDisableAddress(true);
      }
    } else {
      setshouldDisableAddress(false);
    }
  }, [
    shouldDisableAddress,
    addressHistoryData,
    xYearsAddressErrorMessage,
    setShowAddress,
    showAddress,
  ]);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postABMFormFunc("personalInfo", {
      ...fieldValuesPayload,
      addressHistoryData,
      forename: firstName,
      postcode: address && address.postcode,
    });

    history.push("/profile/edit/ABM-onboarding");
  };

  return (
    <FormCreatorV2
      formTitle={"Personal Information"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit} // handles save to JSON
      handleCancel={() => history.push("/profile/edit/ABM-onboarding")}
      onboardingBranch={"ABM"}
      shouldDisableAddress={shouldDisableAddress}
      addressHistoryData={addressHistoryData}
      setAddressHistoryData={setAddressHistoryData}
      addressYearsErrorMessage={xYearsAddressErrorMessage}
      addressValidationErrorMessage={validationErrorMessageAddress}
      setAddressHistoryValue={setValueAddress}
      addressHistoryRemoveLast={removeLastAddress}
    />
  );
};

PersonalInformationForm.propTypes = {
  appData: any,
  postABMFormFunc: func,
};

const mapDispatchToProps = {
  postABMFormFunc: postABMForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(PersonalInformationForm);
